var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 20.0919V17.2162C33 15.9297 32.4097 14.7946 31.4865 14.0378V11.1622C31.4865 8.86162 29.6249 7 27.3243 7H12.1892C9.88865 7 8.02703 8.86162 8.02703 11.1622V14.0378C7.10378 14.7946 6.51351 15.9449 6.51351 17.2162V20.0919C5.59027 20.8486 5 21.9989 5 23.2703V30.8378C5 33.1384 6.86162 35 9.16216 35H30.3514C32.6519 35 34.5135 33.1384 34.5135 30.8378V23.2703C34.5135 21.9838 33.9232 20.8486 33 20.0919ZM10.2973 11.1622C10.2973 10.1178 11.1449 9.27027 12.1892 9.27027H27.3243C28.3686 9.27027 29.2162 10.1178 29.2162 11.1622V13.0995C29.0951 13.0995 28.9741 13.0541 28.8378 13.0541H10.6757C10.5395 13.0541 10.4184 13.0843 10.2973 13.0995V11.1622ZM8.78378 17.2162C8.78378 16.1719 9.63135 15.3243 10.6757 15.3243H28.8378C29.8822 15.3243 30.7297 16.1719 30.7297 17.2162V19.1535C30.6087 19.1535 30.4876 19.1081 30.3514 19.1081H9.16216C9.02595 19.1081 8.90487 19.1384 8.78378 19.1535V17.2162ZM32.2432 30.8378C32.2432 31.8822 31.3957 32.7297 30.3514 32.7297H9.16216C8.11784 32.7297 7.27027 31.8822 7.27027 30.8378V23.2703C7.27027 22.2259 8.11784 21.3784 9.16216 21.3784H30.3514C31.3957 21.3784 32.2432 22.2259 32.2432 23.2703V30.8378Z",
    fill: "#2AAD75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSocial);
export default __webpack_public_path__ + "static/media/allSocial.43503ae9.svg";
export { ForwardRef as ReactComponent };